import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Footer from "../components/Footer";
import BrandMark from "../components/BrandMark";

export default function Consent() {
  const nav = useNavigate();
  const [privacy, setPrivacy] = useState(false);
  const [ai, setAi] = useState(false);
  const [cookies, setCookies] = useState(true);

  const canProceed = privacy && ai;

  const proceed = () => {
    sessionStorage.setItem("srd_consent", JSON.stringify({
      privacy_policy_accepted: privacy,
      ai_processing_accepted: ai,
      cookies_accepted: cookies,
    }));
    nav("/founder");
  };

  return (
    <div className="min-h-screen flex flex-col">
      <div className="border-b border-black/10">
        <div className="max-w-screen-xl mx-auto px-8 py-5"><BrandMark /></div>
      </div>
      <main className="flex-1">
        <div className="max-w-screen-xl mx-auto px-8 py-16 md:py-24 grid md:grid-cols-12 gap-8">
          <div className="md:col-span-4">
            <div className="label-mono">ШАГ 01 / 03</div>
            <h1 className="mt-4 text-4xl md:text-5xl font-medium tracking-tight">Согласия</h1>
            <p className="mt-4 text-foreground/70 leading-relaxed">
              Перед началом нам нужно ваше согласие на обработку данных и&nbsp;использование ИИ для
              анализа открытых ответов. Без этих согласий мы&nbsp;не&nbsp;сможем рассчитать результат.
            </p>
          </div>
          <div className="md:col-span-7 md:col-start-6 space-y-4">
            <Consent152 checked={privacy} onChange={setPrivacy} />
            <ConsentAi checked={ai} onChange={setAi} />
            <ConsentCookies checked={cookies} onChange={setCookies} />
            <div className="pt-8 flex gap-4">
              <button className="btn-secondary" onClick={() => nav("/")}>Назад</button>
              <button data-testid="consent-continue-btn" className="btn-primary" disabled={!canProceed} onClick={proceed}>
                Продолжить <ArrowRight size={16} />
              </button>
            </div>
            {!canProceed && (
              <p className="text-xs text-destructive label-mono">
                Требуются обязательные согласия 01 и 02
              </p>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

function ConsentBlock({ id, num, title, body, checked, onChange, required, dtid }) {
  return (
    <label className={`grid-cell flex gap-4 cursor-pointer ${checked ? "border-foreground" : ""}`}>
      <div className="pt-1">
        <input
          data-testid={dtid}
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="w-5 h-5 accent-black cursor-pointer"
        />
      </div>
      <div className="flex-1">
        <div className="flex items-baseline gap-3">
          <div className="label-mono">{num}</div>
          <div className="text-base font-medium">{title}{required && <span className="text-destructive ml-1">*</span>}</div>
        </div>
        <p className="mt-2 text-sm text-foreground/75 leading-relaxed">{body}</p>
      </div>
    </label>
  );
}

const Consent152 = (p) => (
  <ConsentBlock
    num="CONSENT 01"
    required
    dtid="consent-privacy-checkbox"
    title="Согласие на обработку персональных данных"
    body={
      <>
        Я даю согласие ООО «Методология предпринимательства» (Hop.Agency) на обработку моих персональных
        данных в соответствии с ФЗ&nbsp;№&nbsp;152 «О&nbsp;персональных данных» в целях диагностики
        стартапа. Срок хранения — 12 месяцев. Цели — расчёт индексов и&nbsp;аналитика.{" "}
        <Link to="/privacy" target="_blank" rel="noreferrer" className="hop-link" data-testid="consent-privacy-link">
          Политика обработки ПД ↗
        </Link>{" "}·{" "}
        <Link to="/consent-text" target="_blank" rel="noreferrer" className="hop-link" data-testid="consent-text-link">
          Полный текст согласия ↗
        </Link>
      </>
    }
    {...p}
  />
);

const ConsentAi = (p) => (
  <ConsentBlock
    num="CONSENT 02"
    required
    dtid="consent-ai-checkbox"
    title="Согласие на обработку открытых ответов ИИ-моделью"
    body={
      <>
        Я согласен(на) на&nbsp;то, что мои открытые текстовые ответы и&nbsp;загруженная презентация
        будут переданы языковой модели. Модель анализирует данные, извлекает структурированные
        признаки и&nbsp;участвует в&nbsp;расчёте итоговых индексов вместе с&nbsp;детерминированным
        движком на&nbsp;стороне сервиса.
      </>
    }
    {...p}
  />
);

const ConsentCookies = (p) => (
  <ConsentBlock
    num="CONSENT 03"
    dtid="consent-cookies-checkbox"
    title="Cookies для корректной работы сервиса"
    body={
      <>Только технические cookies. Аналитики и трекеров нет.</>
    }
    {...p}
  />
);
